import { assetUploadService } from "api/assetUploadService";
import { GET_ASSET_TYPES_FAILURE, GET_ASSET_TYPES_REQUEST, GET_ASSET_TYPES_SUCCESS } from "constants/actionTypes";

export const assetType = {
  fetchAssetTypes,
};

function fetchAssetTypes() {
  return async (dispatch: any) => {
    dispatch(request(GET_ASSET_TYPES_REQUEST));
    assetUploadService
      .fetchAssetTypes()
      .then((resp:any) => {
        return resp.json();
      })
      .then((data:any) => {
        console.log("fetchAssetTypes actions", data);
        if (data?.error || data?.message) {
          dispatch(failure(GET_ASSET_TYPES_FAILURE, data?.message || "Error fetching asset types"));
        } else {
          dispatch(success(GET_ASSET_TYPES_SUCCESS, data));
        }
      })
      .catch((error:any) => {
        dispatch(failure(GET_ASSET_TYPES_FAILURE, error));
      });
  };
}

function request(type: string) {
  return { type: type };
}

function success(type: string, data: any) {
  return { type, payload: { data: data } };
}

function failure(type: string, message: string) {
  return { type, payload: { message } };
}
